
export class CheckSiteNameCommand {
  public SiteName: string = "";
  public SubDomain: string = "";
  public Domain: string = "";
}